import { Actions } from './souffranceTransporteurActions';

/**
 * Etat initial
 */
const initialState = {
    items: [],
    isLoading: false,
    isAdding: false,
    fichierId: 0,
    error: '',
    importResult: null
};

/**
 * Reducer pour le domaine "souffranceTransporteur"
 */
const reducer = (state = initialState, action) => {

    switch (action.type) {


        case Actions.FETCH_SOUFFRANCES_TRANSPORTEUR_REQUEST:
            return {
                ...state,
                isLoading: true,
                items: [],
                fichierId: action.fichierId,
                error: '',
                importResult: null
            };
        case Actions.FETCH_SOUFFRANCES_TRANSPORTEUR_SUCCESS:
            {
                return {
                    ...state,
                    isLoading: false,
                    items: action.souffrancesTransporteur,
                    error: ''
                };
            }
        case Actions.FETCH_SOUFFRANCES_TRANSPORTEUR_FAILURE:
            {
                return {
                    ...state,
                    isLoading: false,
                    message: action.message,
                    items: [],
                    error: action
                };
            }
        case Actions.CLEAR_SOUFFRANCES_TRANSPORTEUR:
            return {
                ...initialState
            };
            

        case Actions.IMPORT_SOUFFRANCES_TRANSPORTEUR_REQUEST:
            return {
                ...state,
                isAdding: true,
                items: [],
                fichierId: 0,
                importResult: null,
                error: ''
            };
        case Actions.IMPORT_SOUFFRANCES_TRANSPORTEUR_SUCCESS:
            {
                return {
                    ...state,
                    isAdding: false,
                    importResult: action.importResult,
                    error: ''
                };
            }
        case Actions.IMPORT_SOUFFRANCES_TRANSPORTEUR_FAILURE:
            {
                return {
                    ...state,
                    isAdding: false,
                    message: action.message,
                    error: action
                };
            }

        default:
    }

    return state;
};

export default reducer;